import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { arquivoReferenciaCliente, arquivoReferenciaCampanha, arquivoReferenciaNegocio, arquivoReferenciaCotacao, arquivoReferenciaPedido, arquivoReferenciaPedidoExpedicao, arquivoReferenciaOrcamento } from '../../arquivo-referencia';

@Component({
    selector: 'sgt-arquivo-referencia-multiselect',
    templateUrl: './arquivo-referencia-multiselect.component.html',
    styleUrls: ['./arquivo-referencia-multiselect.component.less']
})
export class ArquivoReferenciaMultiselectComponent implements OnInit {
    /** Referências selecionadas */
    @Input() referencias: number[];
    /** Ao alterar a seleção das referências */
    @Output() referenciasChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = false;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma referência';
    @Input() checked = 'Referência'
    @Input() checkedPlural = 'Referências';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma referência encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowCliente = true;
    @Input() isShowCampanha = true;
    @Input() isShowNegocio = true;
    @Input() isShowCotacao = true;
    @Input() isShowOrcamento = true;
    @Input() isShowPedido = true;
    @Input() isShowPedidoExpedicao = true;
    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-arquivo-referencia ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as referências para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Cliente
        if (this.isShowCliente) {
            selects.push({
                id: arquivoReferenciaCliente.id,
                name: arquivoReferenciaCliente.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-cliente'
            });
        }
        // Campanha
        if (this.isShowCampanha) {
            selects.push({
                id: arquivoReferenciaCampanha.id,
                name: arquivoReferenciaCampanha.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-campanha'
            });
        }
        // Negócio
        if (this.isShowNegocio) {
            selects.push({
                id: arquivoReferenciaNegocio.id,
                name: arquivoReferenciaNegocio.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-negocio'
            });
        }
        // Cotação
        if (this.isShowCotacao) {
            selects.push({
                id: arquivoReferenciaCotacao.id,
                name: arquivoReferenciaCotacao.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-cotacao'
            });
        }
        // Orçamento
        if (this.isShowOrcamento) {
            selects.push({
                id: arquivoReferenciaOrcamento.id,
                name: arquivoReferenciaOrcamento.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-orcamento'
            });
        }
        // Pedido
        if (this.isShowPedido) {
            selects.push({
                id: arquivoReferenciaPedido.id,
                name: arquivoReferenciaPedido.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-pedido'
            });
        }
        // Pedido Expedição
        if (this.isShowPedidoExpedicao) {
            selects.push({
                id: arquivoReferenciaPedidoExpedicao.id,
                name: arquivoReferenciaPedidoExpedicao.nome,
                classes: 'multiselect-item-arquivo-referencia multiselect-item-arquivo-referencia-pedido-expedicao'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das referências */
    onChange() {
        this.referenciasChange.emit(this.referencias);
    }
}
